import { render, staticRenderFns } from "./FeedbackFormSidebar.vue?vue&type=template&id=061a1af8&scoped=true&"
import script from "./FeedbackFormSidebar.vue?vue&type=script&lang=ts&"
export * from "./FeedbackFormSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackFormSidebar.vue?vue&type=style&index=0&id=061a1af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a1af8",
  null
  
)

export default component.exports